import React from "react"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import getMediaQuery from "css/breakpoints"
import { bold } from "css/text"

import { useValue } from "./context"

const FilterItem = styled.div`
  position: relative;
  background-color: transparent;
  border: none;
  padding: 0;
  color: rgb(255 255 255 / 70%);

  & input {
    opacity: 0;
    position: absolute;
  }

  &:first-of-type label {
    margin-inline-start: 0;
  }
  &:last-of-type label {
    margin-inline-end: 0;
  }

  & label {
    ${bold}
    white-space: nowrap;
    margin-inline: 25px;
    cursor: pointer;
    transition: color 0.3s;

    ${getMediaQuery("m")} {
      margin-inline: 30px;
    }

    @media (hover: hover) {
      :hover {
        color: white;
      }
    }
  }

  & input:checked + label {
    color: white;
    cursor: default;
  }
`

const Bullet = styled.span`
  background-color: currentColor;
  border-radius: 50%;
  height: 0.5rem;
  margin-inline-start: 0.5rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 0.5rem;
`

export default function EditoFilterItem({ label, index, _metadata }) {
  const console = useConsole()

  const { currentIndex, setCurrentIndex } = useValue()

  const onChange = () => setCurrentIndex(index)

  return (
    <FilterItem>
      <input id={_metadata.uid} type='radio' value={label} name='edito-filter' checked={currentIndex === index} onChange={onChange} />
      <label htmlFor={_metadata.uid}>
        {label}
        {currentIndex === index ? <Bullet /> : null}
      </label>
    </FilterItem>
  )
}
